import React from 'react'
import { useContext, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import * as yup from "yup"
import { yupResolver } from "@hookform/resolvers/yup"
import { FormProvider, useForm } from "react-hook-form"

import { Button, Dialog, DialogContent, DialogTitle, Grid, IconButton, TextField } from "@mui/material"
import { useTheme } from "@mui/material/styles"
import useMediaQuery from "@mui/material/useMediaQuery"
import CustomTextField from "../CustomTextField"
import CloseIcon from "@mui/icons-material/Close"

import TokenContext from "../../context/TokenContext"
import { UserAuth } from "../../context/AuthContext"

import moment from 'moment'; // Importa moment
import { editarObservacionesMensualesLider, observacionesEvaluacionPGD } from '../../Redux/evaluaciones'
import { useParams } from 'react-router-dom'

const ModalObservaciones = ({ open, handleClose, data, isLider }) => {
    const { id } = useParams();
    const token = useContext(TokenContext)
    const dispatch = useDispatch()
    const theme = useTheme()
    const { empleado } = UserAuth()
    const fullScreen = useMediaQuery(theme.breakpoints.down("md"))
    const defaultValues = {
        new_indicemensual: null,
        new_mes: "",
        new_feedbacklider: ""
    }

    const validacionSchema = yup.object().shape({
        new_feedbacklider: yup.string().required("Por favor indicanos la observación."),
    })

    const { handleSubmit, setValue, reset, ...methods } = useForm({
        shouldUnregister: false,
        defaultValues,
        resolver: yupResolver(validacionSchema),
        mode: "onChange",
        shouldFocusError: true,
    })

    const currentDate = moment();
    const currentMonth = currentDate.format('MMMM');

    const isFeedbackliderDisabled = data?.new_mes?.toLowerCase() !== currentMonth.toLowerCase();

    useEffect(() => {
        if (data) {
            Object.keys(data).forEach((key) => {
                setValue(key, data[key]);
            });
        }
    }, [data, setValue]);

    const submitDatos = (datos) => {
        dispatch(editarObservacionesMensualesLider(token, datos))
            .then(() => {
                cerrarModal();
                dispatch(observacionesEvaluacionPGD(token, id));
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    }

    const cerrarModal = () => {
        handleClose()
        reset()
    }

    return (
        <Dialog
            fullScreen={fullScreen}
            open={open}
            onClose={(event, reason) => {
                if (reason !== 'backdropClick') {
                    cerrarModal();
                }
            }}
            aria-labelledby="responsive-dialog-title"
            disableEscapeKeyDown={true}
        >
            <DialogTitle sx={{ my: 1, textAlign: 'center' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span>Observaciones mensuales</span>
                    <IconButton
                        aria-label="close"
                        onClick={cerrarModal}
                        sx={{
                            p: 1,
                            color: (theme) => theme.palette.grey[500],
                            '&:hover': {
                                color: 'red',
                            },
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </div>
            </DialogTitle>

            <DialogContent>
                <Grid container spacing={2}>
                    <FormProvider {...methods}>
                        <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
                            <CustomTextField
                                Component={TextField}
                                type="text"
                                name="new_mes"
                                label="Mes"
                                rules={{ required: "Required!" }}
                                disabled={true}
                            />
                        </Grid>
                        <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
                            <CustomTextField
                                Component={TextField}
                                type="text"
                                name="new_feedbacklider"
                                label="Observación"
                                rules={{ required: "Required!" }}
                                req={true}
                                disabled={!isLider || isFeedbackliderDisabled}
                            />
                        </Grid>
                        {
                            isLider ? (
                                <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0, mt: 3 }}>
                                    <Button
                                        type="submit"
                                        fullWidth
                                        variant="contained"
                                        onClick={handleSubmit(submitDatos)}
                                        disabled={!isLider || isFeedbackliderDisabled}
                                    >
                                        Enviar
                                    </Button>
                                </Grid>
                            ) : null
                        }
                    </FormProvider>
                </Grid>
            </DialogContent>
        </Dialog>
    )
}

export default ModalObservaciones